module.exports = __webpack_public_path__ + "img/13.c26500a1.png";